export default context => {
    const changeTab = function($input) {
        const isReClick = $input.hasClass('active')
        if(!$input.closest('.tabbed-content').children('section[data-tab]:visible').cancellableTrigger('hide.coing.tabs')) {
            return
        }
        $input.siblings('a').removeClass('active')
        $input.addClass('active')
        const tab = /#(.+)$/.exec($input.attr('href'))
        if (tab !== null) {
            const $tab = $input.closest('.tabbed-content')
                .children('section[data-tab]').hide()
                .filter('[data-tab="' + tab[1] + '"]').show()
            if (!isReClick) {
                $tab.trigger('shown.coing.tabs')
            }
            $input.closest('.tabbed-content nav').trigger('tab-changed.coing.tabs', $input)
        }
    }

    $('.tabbed-content nav', context).on('click', 'a:not(.disabled)', function () {
        changeTab($(this))
    })
        .find('a.active').trigger('click')

    $('.tabbed-content', context).on('select', 'section[data-tab]', function () {
        const $section = $(this)
        $section.closest('.tabbed-content').find(`nav a[href="#${$section.data('tab')}"]`).trigger('click');
    })
}
